<template lang="pug">
  tr
    td(v-if="['worker', 'admin'].indexOf(user_role) !== -1")
      label.checkbox-box
        input(type="checkbox", v-model="product.selected")
        span
    td
      img(:src="product.image")
    td {{ product.title }}
    td
      a(:href='product.getAmazonUrl()', target='_blank') {{ product.asin }}
    td {{ product.fnsku }}
    td {{ product.condition === 0 ? 'Good' : product.condition === 1 ? 'Bad' : 'Attention' }}
    td {{ product.quantity }}
    td(v-if="app_section === 'storage'" v-html="product.getProductsSize()")
    td {{ product.received_date }}
    td {{ product.client_comment }}
    td {{ product.worker_comment }}
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: [
      'product',
    ],
    computed: {
      user_role() {
        return this.$store.state.users.role;
      },
      app_section() {
        return this.$store.getters.get_app_section;
      },
    },
  };
</script>
